import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useAuth} from 'app/modules/auth/core/Auth'
import {useNavigate} from 'react-router-dom'
import LecturerDashboard from 'app/modules/dua/Lecturer/LecturerDashboard'
import StudentDashboard from 'app/modules/dua/Student-Portal/StudentDashboard'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  const position = currentUser?.position
  const sys = localStorage.getItem('system_id')
  const systemId = Number(sys)

  // ✅ Hook 1 (always runs)
  useEffect(() => {
    if (currentUser?.systems) {
      const timer = setTimeout(() => setLoading(false), 500)
      return () => clearTimeout(timer)
    }
  }, [currentUser?.systems])

  // ✅ Hook 2 (always runs)
  useEffect(() => {
    if (!sys || isNaN(systemId)) return

    if (systemId === 1) navigate('/system-mgt/home')
    else if (systemId === 2) navigate('/dua/home')
    else if (systemId === 3) navigate('/dphs/home')
    else if (systemId === 5) navigate('/canteen/home')
  }, [sys, systemId, navigate])

  // ⏳ loading state
  if (loading) return <Loader />

  // ✅ Role-based dashboards
  if (currentUser?.roles?.includes('Lecturer') && position === 'Lecturer') {
    return <LecturerDashboard />
  }

  if (currentUser?.roles?.includes('Student') && position === 'Student') {
    return <StudentDashboard />
  }

  // ✅ fallback (never return undefined)
  return <Loader />
}

export {DashboardWrapper}
